/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLegalEntityCertificate200Response
 */
export interface GetLegalEntityCertificate200Response {
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityCertificate200Response
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetLegalEntityCertificate200Response
     */
    expiresAt?: string;
}

/**
 * Check if a given object implements the GetLegalEntityCertificate200Response interface.
 */
export function instanceOfGetLegalEntityCertificate200Response(value: object): value is GetLegalEntityCertificate200Response {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetLegalEntityCertificate200ResponseFromJSON(json: any): GetLegalEntityCertificate200Response {
    return GetLegalEntityCertificate200ResponseFromJSONTyped(json, false);
}

export function GetLegalEntityCertificate200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLegalEntityCertificate200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': json['updatedAt'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
    };
}

export function GetLegalEntityCertificate200ResponseToJSON(json: any): GetLegalEntityCertificate200Response {
    return GetLegalEntityCertificate200ResponseToJSONTyped(json, false);
}

export function GetLegalEntityCertificate200ResponseToJSONTyped(value?: GetLegalEntityCertificate200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedAt': value['updatedAt'],
        'expiresAt': value['expiresAt'],
    };
}

